import { useToast } from '@/hooks/use-toast';
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';

export function Toaster() {
  const { toasts } = useToast();
  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, level, variant, ...props }) {
        const notificationLevel = normalizeLevel(level || variant);
        return (
          <Toast key={id} variant={notificationLevel} data-level={notificationLevel} {...props}>
            <ToastLevelIcon level={notificationLevel} />
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}

function ToastLevelIcon({ level }) {
  const className = 'mt-0.5 h-4 w-4 shrink-0';
  if (level === 'success') return <CheckCircle2 className={className} aria-hidden="true" />;
  if (level === 'warning') return <AlertTriangle className={className} aria-hidden="true" />;
  if (level === 'error') return <XCircle className={className} aria-hidden="true" />;
  return <Info className={className} aria-hidden="true" />;
}

function normalizeLevel(value) {
  if (value === 'success' || value === 'warning' || value === 'error' || value === 'info') return value;
  if (value === 'destructive') return 'error';
  return 'info';
}
